export default "__VITE_ASSET__Co3W3GHI__"